/* Important
All state types & functions should be imported from this file.
https://medium.com/visual-development/how-to-fix-nasty-circular-dependency-issues-once-and-for-all-in-javascript-typescript-a04c987cf0de
 */

// Portal API hooks - Export RTK Query hooks first to prevent circular dependencies
export {
  useCreateRegistrationMutation,
  useConfirmRegistrationMobileMutation,
  useConfirmRegistrationMutation,
} from '@afterpaytouch/portal-api/consumer/registrations'

export { useFinaliseAccountDetailsMutation } from '@afterpaytouch/portal-api/consumer/account'

// Types
export * from './types'

// Store
export * from './store'
export * from './request'
export * from './api'

// Actions
export * from './actions'
export * from './account/consumer/actions'
export * from './auth/user/actions'
export * from './applepay/actions'
export * from './cardScan/action'
export * from './registration/actions'

// Hooks
export * from './hooks'
export * from './account/account.hooks'
export * from './account/creditLimit/hooks'
export * from './account/progression/hooks'
export * from './account/sessions/sessions.hooks'
export * from './account/oauth/oauth.hooks'
export * from './account/changePassword/changePassword.hooks'
export * from './account/biometric/biometric.hooks'
export * from './auth/user/hooks'
export * from './auth/user/selectors'
export * from './registration/hooks'
export * from './orders/hooks'
export * from './paymentSchedule/hooks'
export * from './paymentReschedule/hooks'
export * from './creditCards/hooks'
export * from './topaz/hooks'
export * from './shop/hooks'
export * from './applepay/hooks'
export * from './paymentRouting/hooks'
export * from './subscriptions/hooks'
export * from './enabledCards/hooks'
export * from './amountDueSummary/hooks'
export * from './bankAccounts/hooks'
export * from './billingAgreements/hooks'
export * from './cardScan/hooks'
export * from './hardship/hooks'
export * from './emails/emails.hooks'
export * from './identity/hooks'
export {
  setBiometricApplicantId,
  setBiometricOptOut,
  setSkipBiometricCheck,
  setSessionIdVisibility,
  resetIdentityState,
  identityReducer,
  identityInitialState,
} from './identity/reducer'
export type { IdentityState } from './identity/reducer'
export * from './preferredPaymentDay/hooks'
export * from './bankingSessions/hooks'
export * from './dispute/hooks'
export * from './checkout/hooks'
export * from './experiments/hooks'
export * from './experiments/selectors'

// Reducers
export * from './auth/user/reducer'
export * from './applepay/reducer'
export * from './cardScan/reducer'
export * from './dispute/reducer'
export * from './account/consumer/reducer'
export * from './registration/reducer'
export * from './experiments/reducer'

// Services
export * from './payments'
export * from './loyalty'
export * from './consumerLending'
export * from './tags'
export * from './creditFacility'

// utils
export * from './paymentSchedule/utils'
export * from './subscriptions/utils'
export * from './hardship/utils'
